// rrweb DOM-session recording. rrweb is bundled at build time (pinned npm dependency) — no
// runtime CDN import, so strict host-page CSP and third-party availability are non-issues.
//
// Privacy defaults: ALL input values are masked (not just passwords) — feedback narration
// rarely needs typed values, and a client's users may type emails/cards/keys. Hosts can widen
// or narrow via cfg.mask (extra text to mask) and cfg.block (subtrees not recorded at all).

import { record } from 'rrweb';

export const RRWEB_VERSION = '2.1.0'; // keep in lockstep with package.json

const WIDGET_SELECTOR = '[data-ff-root]'; // never record our own UI into the replay

export async function startRrweb(onEvent, cfg = {}) {
  let stopFn;
  try {
    stopFn = record({
      emit: (ev) => onEvent(ev),
      maskAllInputs: true,
      maskTextSelector: (cfg.mask && cfg.mask.length ? cfg.mask.join(',') : null) || undefined,
      blockSelector: [WIDGET_SELECTOR].concat(cfg.block || []).join(','),
      recordCanvas: false,
      sampling: { mousemove: 50, scroll: 100, input: 'last' },
      slimDOMOptions: { script: true, comment: true },
    });
  } catch (e) {
    console.warn('[ff] rrweb record() threw; continuing without DOM capture', e);
    return { ok: false, stop() {} };
  }

  return {
    ok: true,
    stop() { try { if (stopFn) stopFn(); } catch (_) {} },
  };
}
